import React from 'react';
import ForgotPasswordComponent from './forgot-password.component';

function ForgotPassword() {
    return <ForgotPasswordComponent />;
}

export default ForgotPassword;
